import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.animateCSS("bounceInRight", () =>
      setTimeout(() => this.dismiss(), 5000)
    );
  }

  animateCSS(animation, callback = null, prefix = "animate__") {
    new Promise((resolve, reject) => {
      const animationName = `${prefix}${animation}`;

      this.element.classList.add(`${prefix}animated`, animationName);

      const handleAnimationEnd = (event) => {
        event.stopPropagation();
        this.element.classList.remove(`${prefix}animated`, animationName);
        resolve("Animation ended");
        if (callback) {
          callback();
        }
      };

      this.element.addEventListener("animationend", handleAnimationEnd, {
        once: true,
      });
    });
  }

  dismiss() {
    this.animateCSS("bounceOutRight", () => {
      this.element.remove();
    });
  }
}
